import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Config } from '@core/configuration';
import { Anchor as MantineAnchor, polymorphicFactory } from '@coveord/plasma-mantine';
import { useMemo } from 'react';
export var Anchor = polymorphicFactory(function(props, ref) {
    var rest = props;
    var externalLink = useMemo(function() {
        if (!(rest === null || rest === void 0 ? void 0 : rest.href)) {
            return false;
        }
        var url;
        try {
            url = new URL(rest.href);
        } catch (unused) {
            return false;
        }
        return "".concat(url.protocol, "//").concat(url.hostname) !== Config.CloudPlatform.url;
    }, [
        rest === null || rest === void 0 ? void 0 : rest.href
    ]);
    var anchorProps = externalLink ? _object_spread_props(_object_spread({}, rest), {
        target: '_blank',
        rel: 'noopener noreferrer'
    }) : rest;
    return /*#__PURE__*/ _jsx(MantineAnchor, _object_spread({
        ref: ref
    }, anchorProps));
});

//# sourceMappingURL=Anchor.js.map